var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { isEmpty } from "@aws-amplify/core";
import { Box, Button, CircularProgress, Input, Typography } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import { Auth } from "aws-amplify";
import React from "react";
import "../styles/AuthStylesheet.css";
import maternaTheme from "../styles/materna_theme";
import { CHALLENGE_NEW_PASSWORD, CHALLENGE_SETUP, CHALLENGE_SMS, CHALLENGE_TOKEN } from "./auth_util";
import AuthComponent, { STATE_REQUIRE_NEW_PASSWORD, STATE_SETUP, STATE_SIGN_IN, STATE_SIGN_IN_CONFIRM, STATE_SIGN_UP, STATE_SIGN_UP_CONFIRM, STATE_SIGNED_IN, STATE_SIGNED_OUT, STATE_VERIFY_CONTACT } from "./AuthComponent";
import ForgotPasswordDialog from "./ForgotPasswordDialog";
import { getCurrentUser } from "./GetCurrentUser";
import { injectIntl } from "react-intl";
var VALID_AUTH_STATES = [STATE_SIGN_IN, STATE_SIGNED_OUT];
var SignInComponent = /** @class */ (function (_super) {
    __extends(SignInComponent, _super);
    function SignInComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.onForgotPasswordDialogClosed = function () {
            _this.setState({ forgotPasswordDialogOpen: false });
        };
        _this.handleEmailChange = function (email) {
            _this.setState({
                email: email,
                signInButtonActive: email.length > 0 && _this.state.password.length > 0
            });
        };
        _this.handlePasswordChange = function (password) {
            _this.setState({
                password: password,
                signInButtonActive: _this.state.email.length > 0 && password.length > 0
            });
        };
        _this.onForgotPasswordClicked = function () {
            _this.setState({ forgotPasswordDialogOpen: true });
        };
        _this.onSignUpClicked = function () {
            _this.changeAuthState(STATE_SIGN_UP);
        };
        _this.signOut = function () {
            Auth.signOut()
                .then(function (data) { return data && console.log(data); })
                .catch(function (err) { return console.log(err); });
        };
        _this.onEnterPressed = function (evt) {
            if (evt.key === "Enter" && _this.state.signInButtonActive) {
                _this.onSignInClicked();
            }
        };
        _this.testButton = function () {
            // @ts-ignore
            //Auth.federatedSignIn({provider: "MaternaADFSTest"})
            window.location.href = _this.props.adfs_url;
        };
        _this.onSignInClicked = function () {
            var errorMessage = _this.validateData();
            if (errorMessage) {
                _this.setState({
                    errorMessage: errorMessage
                });
                return;
            }
            _this.setState({
                loading: true
            });
            _this.setState({
                errorMessage: ""
            });
            Auth.signIn(_this.state.email.toLowerCase(), _this.state.password)
                .then(function (user) {
                getCurrentUser()
                    .then(function (currentUser) {
                    if (_this.props.adminsOnly && !currentUser.isAdmin) {
                        _this.signOut();
                        _this.setState({ loading: false });
                        _this.setState({
                            errorMessage: _this.intl.formatMessage({ id: "authentication-login_form-error-admin_only" })
                        });
                    }
                    if (_this.props.requireAcl && !currentUser.isAuthorized) {
                        _this.signOut();
                        _this.setState({ loading: false });
                        _this.setState({
                            errorMessage: _this.intl.formatMessage({ id: "authentication-login_form-error-acl-not-authorized" })
                        });
                    }
                    else {
                        _this.handleSignInResult(user);
                    }
                })
                    .catch(function () {
                    _this.signOut();
                });
            })
                .catch(function (err) {
                _this.setState({
                    loading: false
                });
                if (err.code === "UserNotConfirmedException") {
                    _this.changeAuthState(STATE_SIGN_UP_CONFIRM, { username: _this.state.email });
                }
                else if (err.code === "NotAuthorizedException") {
                    if (err.message === "User is disabled.") {
                        _this.setState({
                            errorMessage: _this.intl.formatMessage({ id: "authentication-login_form-error-user_is_disabled" })
                        });
                    }
                    else if (err.message === "Incorrect username or password.") {
                        _this.setState({
                            errorMessage: _this.intl.formatMessage({ id: "authentication-login_form-error-incorrect_credentials" })
                        });
                    }
                    else {
                        _this.setState({
                            errorMessage: _this.intl.formatMessage({ id: "authentication-default_error_message" }, { errMsg: err.message })
                        });
                    }
                }
                else {
                    _this.setState({
                        errorMessage: _this.intl.formatMessage({ id: "authentication-default_error_message" }, { errMsg: err.message })
                    });
                }
            });
        };
        _this.state = {
            email: "",
            password: "",
            forgotPasswordDialogOpen: false,
            loading: false,
            signInButtonActive: false,
            errorMessage: ""
        };
        _this.intl = props.intl;
        return _this;
    }
    // @ts-ignore: The unneeded parameters
    SignInComponent.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (this.props.authData && this.props.authData.signInError) {
            this.setState({ errorMessage: this.props.authData.signInError });
        }
        if (prevProps.authState === STATE_SIGNED_IN)
            this.resetState();
    };
    SignInComponent.prototype.componentDidMount = function () {
        this.resetState();
    };
    SignInComponent.prototype.getValidAuthStates = function () {
        return VALID_AUTH_STATES;
    };
    // @ts-ignore: The unneeded parameter
    SignInComponent.prototype.renderComponent = function (currentAuthState) {
        var _a;
        var headerText = this.intl.formatMessage({ id: "authentication-login_form-header" }, { appName: (_a = process.env.REACT_APP_APP_NAME) !== null && _a !== void 0 ? _a : "undefined" });
        return (React.createElement(ThemeProvider, { theme: maternaTheme },
            React.createElement("div", { className: "container" },
                React.createElement("h2", { className: "auth-headline" }, headerText),
                React.createElement("form", null,
                    this.renderEmailInput(),
                    this.renderPasswordInput(),
                    this.renderForgotPasswordLink(),
                    React.createElement("div", { className: "auth-block" }, this.renderError()),
                    this.renderSignInButton(),
                    this.state.email === "mellon" && this.renderSignInWithADFS(),
                    this.renderSignUpLink())),
            this.renderForgotPasswordDialog()));
    };
    SignInComponent.prototype.renderEmailInput = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("label", { className: "label" },
                this.intl.formatMessage({ id: "authentication-login_form-email" }),
                " *"),
            React.createElement(Box, { width: 300 },
                React.createElement(Input, { className: "input", fullWidth: true, onKeyDown: this.onEnterPressed, onChange: function (evt) { return _this.handleEmailChange(evt.target.value); }, type: "text", placeholder: this.intl.formatMessage({ id: "authentication-login_form-email" }), required: true }))));
    };
    SignInComponent.prototype.renderPasswordInput = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("label", { className: "label" },
                this.intl.formatMessage({ id: "authentication-login_form-password" }),
                " *"),
            React.createElement(Box, { width: 300 },
                React.createElement(Input, { className: "input", fullWidth: true, onKeyDown: this.onEnterPressed, onChange: function (evt) { return _this.handlePasswordChange(evt.target.value); }, type: "password", placeholder: this.intl.formatMessage({ id: "authentication-login_form-password" }), required: true }))));
    };
    SignInComponent.prototype.renderError = function () {
        var errorMessage = this.state.errorMessage;
        if (errorMessage === "")
            return null;
        return (React.createElement("p", { className: "error" }, errorMessage));
    };
    SignInComponent.prototype.renderSignInButton = function () {
        return (React.createElement(Box, { width: 300, padding: 1, display: "flex", justifyContent: "center" },
            React.createElement(Button, { fullWidth: true, variant: "contained", color: "primary", disabled: !this.state.signInButtonActive || this.state.loading, className: "button", onClick: this.onSignInClicked },
                React.createElement("span", null,
                    this.renderLoading(),
                    this.intl.formatMessage({ id: "authentication-login_form-login_button-text" })))));
    };
    SignInComponent.prototype.renderSignInWithADFS = function () {
        return (React.createElement(Box, { width: 300, padding: 1, display: "flex", justifyContent: "center" },
            React.createElement(Button, { fullWidth: true, variant: "contained", color: "primary", className: "button", onClick: this.testButton },
                React.createElement("span", null,
                    this.renderLoading(),
                    this.intl.formatMessage({ id: "authentication-login_form-adfs_button-text" })))));
    };
    SignInComponent.prototype.renderLoading = function () {
        if (!this.state.loading)
            return null;
        return (React.createElement(CircularProgress, { className: "progress", color: "inherit", size: 20 }));
    };
    SignInComponent.prototype.renderForgotPasswordLink = function () {
        return (React.createElement("a", { className: "auth-link", onClick: this.onForgotPasswordClicked }, this.intl.formatMessage({ id: "authentication-login_form-forgot_password-link-text" })));
    };
    SignInComponent.prototype.renderSignUpLink = function () {
        return (React.createElement("div", { className: "auth-block" },
            React.createElement(Typography, { className: "auth-text-inline" }, this.intl.formatMessage({ id: "authentication-login_form-register_cta-question" })),
            React.createElement("a", { className: "auth-link-inline", onClick: this.onSignUpClicked }, this.intl.formatMessage({ id: "authentication-login_form-register_cta-link-text" }))));
    };
    SignInComponent.prototype.renderForgotPasswordDialog = function () {
        if (this.state.forgotPasswordDialogOpen)
            return React.createElement(ForgotPasswordDialog, { onClose: this.onForgotPasswordDialogClosed });
        return null;
    };
    SignInComponent.prototype.validateData = function () {
        if (this.state.email.trim() === "" || this.state.password.trim() === "")
            return this.intl.formatMessage({ id: "authentication-login_form-error-incomplete_form" });
        return undefined;
    };
    SignInComponent.prototype.resetState = function () {
        this.setState({
            email: "",
            password: "",
            loading: false,
            forgotPasswordDialogOpen: false
        });
    };
    SignInComponent.prototype.handleSignInResult = function (user) {
        var challengeName = user.challengeName;
        switch (challengeName) {
            case CHALLENGE_SMS:
            case CHALLENGE_TOKEN:
                this.changeAuthState(STATE_SIGN_IN_CONFIRM, user);
                break;
            case CHALLENGE_NEW_PASSWORD:
                this.changeAuthState(STATE_REQUIRE_NEW_PASSWORD, user);
                break;
            case CHALLENGE_SETUP:
                this.changeAuthState(STATE_SETUP, user);
                break;
            default:
                this.checkContact(user);
        }
    };
    SignInComponent.prototype.checkContact = function (user) {
        var _this = this;
        Auth.verifiedContact(user).then(function (data) {
            if (!isEmpty(data.verified))
                _this.changeAuthState(STATE_SIGNED_IN, user);
            else
                _this.changeAuthState(STATE_VERIFY_CONTACT, Object.assign(user, data));
        });
    };
    return SignInComponent;
}(AuthComponent));
export { SignInComponent };
// @ts-ignore due to injectIntl messing up component signatures
export default injectIntl(SignInComponent);
//# sourceMappingURL=SignInComponent.js.map